import { render, staticRenderFns } from "./customerInterviewRecordRD.vue?vue&type=template&id=93775756&scoped=true&"
import script from "./customerInterviewRecordRD.vue?vue&type=script&lang=js&"
export * from "./customerInterviewRecordRD.vue?vue&type=script&lang=js&"
import style0 from "./customerInterviewRecordRD.vue?vue&type=style&index=0&id=93775756&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93775756",
  null
  
)

export default component.exports